<script>
  import {supportsLogin} from "./services/configService";
  import {slide, fade} from "svelte/transition";
  import {authStore} from "./stores/authStore";

  let showLoginForm = false;
  const collapsedHeight = "38px";
  const authlog = true;
  let completeHeight = "auto";
  let height = collapsedHeight;
  let username = "";
  let password = "";

  function handleLogin() {
    authStore.login(username, password);
  }

  function toggleLogin() {
    showLoginForm = !showLoginForm;
  }

  authStore.subscribe((s) => {
    if (s.loggedIn) {
      showLoginForm = false;
    }
  });
  // TODO: unsubscribe

  $: height = showLoginForm ? completeHeight : collapsedHeight;
  $: thereIsErrorLogin = errorLoggingIn($authStore.errorLogin);

  function errorLoggingIn(error) {
    if (error) {
      completeHeight = "auto";
      height = "auto";
    }
  }

  function getFirstLetter(string) {
    string = (string)?string:"null";
    return Array.from(string)[0]
  }


</script>

{#if supportsLogin()}
    {#if !$authStore.loggedIn}
          <div class="vec-w-full vec-flex vec-items-center vec-justify-center md:vec-justify-end">
            <div class="vec-mr-3">To track your progress </div>
            <button
              on:click={toggleLogin} class="vec-inline-block vec-cursor-pointer vec-text-center vec-bg-white vec-font-normal vec-rounded-md vec-rounded-bl-none vec-px-3 vec-py-2 vec-border hover:vec-bg-gradient-to-b hover:vec-from-white hover:vec-via-lightGrey hover:vec-to-lightGrey focus:vec-ring-4 active:vec-from-lightGrey active:vec-via-lightGrey active:vec-to-white vec-bg-none vec-text-black vec-border-darkerGrey focus:vec-ring-black/10 vec-text-md">
              Login</button>
          </div>        
      <div
        class="vec-absolute vec--top-1 vec--right-1 vec-w-[calc(100%+0.5rem)] md:vec-max-w-[400px] vec-z-20 {(showLoginForm)?"vec-block":"vec-hidden"}">
        {#if showLoginForm}          
            <div class="vec-w-full vec-relative vec-p-5 vec-space-y-4 vec-text-left vec-bg-white vec-rounded-xl vec-rounded-bl-none" style="box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 20px;" in:fade={{ delay: 0 }}>
              <div>
                <button
                  on:click={toggleLogin}
                  class="vec-flex vec-p-5 vec-ml-auto vec--my-5 vec--mr-5">
                <svg class="vec-m-auto vec-fill-black vec-m-auto" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
                <span class="sr-only">Close login</span>
              </button>
              </div>
              {#if $authStore.errorLogin}
                <div in:fade={{ delay: 0 }}>
                  <p class="vec-text-aspire vec-text-center">Incorrect username or password</p>
                </div>
              {/if}
              <div>
                <label for="tracking_email" class="sr-only"
                >Email Address</label
                >
                <input
                  bind:value={username}
                  type="text"
                  id="tracking_email"
                  placeholder="Email address"
                  class="vec-border vec-rounded-md vec-rounded-bl-none vec-px-2 vec-w-full vec-h-12 vec-text-black focus:vec-ring-4 vec-outline-none {($authStore.errorLogin)?"vec-border-aspire focus:vec-ring-aspire/10 vec-pr-[2.25rem]":"vec-border-midGrey focus:vec-ring-black/10"}"
                />
              </div>

              <div>
                <label for="tracking_password" class="sr-only"
                >Password</label
                >
                <input
                  bind:value={password}
                  type="password"
                  id="tracking_password"
                  placeholder="Password"
                  class="vec-border vec-rounded-md vec-rounded-bl-none vec-px-2 vec-w-full vec-h-12 vec-text-black focus:vec-ring-4 vec-outline-none {($authStore.errorLogin)?"vec-border-aspire focus:vec-ring-aspire/10 vec-pr-[2.25rem]":"vec-border-midGrey focus:vec-ring-black/10"}"
                />
              </div>
              {#if $authStore.loggingIn}
              <div class="vec-text-center vec-flex vec-rounded-md vec-rounded-bl-none vec-border vec-bg-gradient-to-b vec-from-[#F8B002] vec-via-primary vec-via-33% vec-to-[#F8B002] vec-w-full vec-h-[38px]">
                <div class="vec-w-6 vec-h-6 vec-m-auto vec-bg-white/25 vec-p-[2px] vec-rounded-full">
                  <div class="spinner"></div>
                </div>
              </div>
              {:else}
              <button
                on:click={handleLogin}
                class="vec-text-center vec-inline-block vec-font-normal vec-rounded-md vec-rounded-bl-none vec-px-3 vec-py-2 vec-border hover:vec-bg-gradient-to-b hover:vec-from-white hover:via-lightGrey hover:vec-to-lightGrey focus:vec-ring-4 active:vec-from-lightGrey active:vec-via-lightGrey active:vec-to-white vec-text-black vec-border vec-border-white/0 hover:vec-vec-border hover:vec-border-primary vec-bg-gradient-to-b vec-from-[#F8B002] vec-via-primary vec-via-33% vec-to-[#F8B002] focus:vec-ring-primary50 vec-text-md vec-w-full"
              >Login
              </button>
              {/if}
              <div><a
                href="https://portal.vectric.com/signup" target="_blank"
                class="vec-pointer-events-auto vec-text-center vec-bg-white vec-inline-block vec-sm:mr-3 vec-font-normal vec-rounded-md vec-rounded-bl-none vec-px-3 vec-py-2 vec-border hover:vec-bg-gradient-to-b hover:vec-from-white hover:vec-via-lightGrey hover:vec-to-lightGrey focus:vec-ring-4 active:vec-from-lightGrey active:vec-via-lightGrey active:vec-to-white vec-bg-none vec-text-black vec-border-darkerGrey focus:vec-ring-black/10 vec-text-md vec-w-full"
              >Not got an account? Register
            </a></div>
            <div><a href="https://portal.vectric.com/forgotpassword" target="_blank" class="vec-block vec-text-center vec-text-sm vec-underline hover:vec-opacity-50">Forgot your password?</a></div>
              
            </div>
        {/if}
      </div>
    {:else}
    <div class="vec-w-full vec-flex vec-items-center vec-justify-end">
        <div class="vec-text-sm vec-mr-2"> Logged in as <strong>{$authStore.user.email}</strong></div>
        <div class="vec-block vec-flex vec-h-12 vec-w-12 vec-border vec-border-[#C68D00] vec-rounded-full vec-overflow-hidden vec-bg-primary vec-text-black vec-uppercase vec-my-[-5px]">
          <div class="vec-m-auto vec-text-2xl vec-font-light">{getFirstLetter($authStore.user.email)}</div>
        </div>
      </div>
    {/if}
{/if}

<style>

    .spinner {
        display: inline-block;
        width: 20px;
        height: 20px;
        border: 2px solid rgba(255,255,255, 0);
        border-radius: 50%;
        border-top-color: #fff;
        border-right-color: #fff;
        /* animation: spin 1s ease-in-out infinite; */
        -webkit-animation: spin 0.5s linear infinite;
    }

    @keyframes spin {
        25% {
            -webkit-transform: rotate(90deg);
        }
        50% {
            -webkit-transform: rotate(181deg);
        }
        75% {
            -webkit-transform: rotate(270deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
        }
    }

</style>
